import { useEffect } from 'react';
import confetti from 'canvas-confetti';
import type { Options as ConfettiOptions } from 'canvas-confetti';
import { useWelcomeContext } from './WelcomeContext';

/**
 * Celebration confetti burst on mount, shared by completion screens.
 * Suppressed in the admin preview modal and for prefers-reduced-motion.
 */
export function useDoneConfetti(options?: { enabled?: boolean }) {
  const { isPreview } = useWelcomeContext();
  const enabled = options?.enabled ?? true;

  useEffect(() => {
    if (!enabled) return;
    // Don't celebrate a real completion when an admin is just previewing the flow.
    if (isPreview) return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq.matches) return;

    const fire = (opts: ConfettiOptions) => {
      try {
        void confetti({ ...opts, disableForReducedMotion: true, zIndex: 9999 });
      } catch {
        /* ignore */
      }
    };

    fire({
      particleCount: 160,
      spread: 360,
      origin: { x: 0.5, y: 0.42 },
      startVelocity: 40,
      gravity: 0.82,
      ticks: 240,
      scalar: 1.45,
    });

    const t2 = window.setTimeout(() => {
      fire({
        particleCount: 100,
        spread: 360,
        origin: { x: 0.5, y: 0.5 },
        startVelocity: 32,
        gravity: 0.92,
        ticks: 200,
        scalar: 1.2,
        shapes: ['circle'],
      });
    }, 220);

    return () => window.clearTimeout(t2);
  }, [enabled, isPreview]);
}
